import { DatePicker } from 'antd';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { useTranslation } from 'react-i18next';

dayjs.extend(customParseFormat);

const dateFormat = 'DD/MM/YYYY';
export function KFDate({ onChangeInput, value, rootStyle, style, onChange, ...rest }: any) {
    const {t} = useTranslation();
    return (
        <div style={{ display: "flex", justifyContent: "flex-start", flexDirection: "column", rowGap: 5, ...rootStyle }} >
            <DatePicker
                onChange={(_, dateString) => {
                    onChangeInput(dateString)
                    if (onChange) {
                        onChange(_, dateString);
                    }
                }}
                style={{ height: 44, ...style }}
                picker="date"
                format={dateFormat}
                placeholder={t("Select date")}
                {...rest}
                value={value ? dayjs(value, dateFormat) : null}
            />
        </div>
    )
}
